define(["require", "exports", "../bootstrap/BootstrapBus"], function (require, exports, BootstrapBus_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.ServiceStatus = void 0;
    var ServiceStatus = (function () {
        function ServiceStatus() {
            this.loadingRequests = 0;
            this.lastDisplayTipTime = 0;
        }
        ServiceStatus.prototype.updateConfig = function (tempConfig) {
            this.configData = tempConfig;
            this.i18n = this.configData.i18n;
        };
        ServiceStatus.prototype.handleLogicalTips = function (response) {
            if (response && response.data) {
                if (response.data.message && response.data.status && response.data.status !== 0) {
                    var displayTip = "Message: ".concat(response.data.status, " ").concat(response.data.message);
                    this.showError(displayTip);
                    return;
                }
                if (response.data.errorCode && response.data.errorMsg && response.data.successful !== 1) {
                    var displayTip = "Message: ".concat(response.data.errorCode, " ").concat(response.data.errorMsg);
                    this.showError(displayTip);
                    return;
                }
                if (response.data.code && response.data.msg && response.data.code !== 200 && response.data.code !== -1) {
                    if (this.configData.networkInterceptorsHandler) {
                        var responseMessage = this.configData.networkInterceptorsHandler(response);
                        if (responseMessage) {
                            this.showError(responseMessage);
                        }
                        return;
                    }
                    else {
                        var displayTip = "Message: ".concat(response.data.code, " ").concat(response.data.msg);
                        this.showError(displayTip);
                        return;
                    }
                }
                if (this.configData.networkInterceptorsHandler) {
                    var responseMessage = this.configData.networkInterceptorsHandler(response);
                    if (responseMessage) {
                        this.showError(responseMessage);
                    }
                    return;
                }
            }
        };
        ServiceStatus.prototype.getErrorMessageFromI18n = function (type, defaultPreMsgStr) {
            var resultStr = defaultPreMsgStr;
            if (this.i18n &&
                this.i18n.messages &&
                this.i18n.messages[this.i18n.locale] &&
                this.i18n.messages[this.i18n.locale].msg &&
                this.i18n.messages[this.i18n.locale].msg.error) {
                if (this.i18n.messages[this.i18n.locale].msg.error[type]) {
                    resultStr = this.i18n.messages[this.i18n.locale].msg.error[type];
                }
            }
            return resultStr;
        };
        ServiceStatus.prototype.handleErrors = function (error) {
            if (error && error.response) {
                var defaultPreMsgCode = "[Code-".concat(error.response.status, "]:");
                var defaultPreMsgStr = error.response.message || error.response.statusText || error.response.data ? error.response.data.message : 'response errors.' || '';
                var message = '';
                switch (error.response.status) {
                    case 400:
                        message = "".concat(defaultPreMsgCode).concat(this.getErrorMessageFromI18n('badRequest', defaultPreMsgStr));
                        this.showError(message);
                        break;
                    case 401:
                        console.log('401 用户通过ajax请求访问页面时，提示错误信息并在2s后跳转登录页');
                        message = "".concat(defaultPreMsgCode).concat(this.getErrorMessageFromI18n('unauthorized', defaultPreMsgStr));
                        this.handleUnauthorized(error, message);
                        break;
                    case 403:
                        message = "".concat(defaultPreMsgCode).concat(this.getErrorMessageFromI18n('forbidden', defaultPreMsgStr));
                        this.showError(message);
                        this.showForbidden(message);
                        this.showForbiddenDetail({ message: message, error: error });
                        break;
                    case 404:
                        console.log('handle: ', error.response.status, error.response);
                        break;
                    case 500:
                        var code = error.response.data.code;
                        var details = error.response.data.details;
                        message = "[CODE-".concat(code, "]:");
                        if (!details || !details.length) {
                            if (this.configData.networkInterceptorsHandler) {
                                var responseMessage = this.configData.networkInterceptorsHandler(error.response);
                                if (responseMessage) {
                                    this.showError(responseMessage);
                                }
                            }
                            else {
                                message += error.response.data.message || error.response.data.msg;
                                this.showError(message);
                            }
                        }
                        else if (!this.isOnlyWarning(details)) {
                            var hasDetail = this.getErrorMessageFromI18n('hasDetail', defaultPreMsgStr);
                            message += hasDetail;
                            details = details.filter(function (item) {
                                return item.type === 0;
                            });
                            this.showErrorWithDetail(message, details);
                        }
                        break;
                    default:
                        break;
                }
            }
            else {
                console.log('HandleError..', error);
            }
        };
        ServiceStatus.prototype.handleUnauthorized = function (error, message) {
            var url = window.location.href;
            console.log('handleUnauthorized start.');
            if (this.configData && this.configData.useJarvixsLogin) {
                BootstrapBus_1.busEvent.$emit(BootstrapBus_1.EventBusEnum.APPS_LOGIN_CHECK, { error: error, message: message });
                return;
            }
            if (this.configData && this.configData.useUnDelayMode) {
                this.showError(message);
                var useLocalLoginUrl = this.configData.useLocalLoginUrl ? this.configData.useLocalLoginUrl : '/api/checkLogin?callback=';
                var redirectUrl = "//".concat(window.location.host).concat(useLocalLoginUrl) + encodeURIComponent(window.location.href);
                console.log('handleUnauthorized strt. UNDELAYED STANDARD ==>', redirectUrl);
                window.location.href = redirectUrl;
                return;
            }
            if (this.configData && this.configData.useStandardLogin) {
                this.showError(message);
                setTimeout(function () {
                    var redirectUrl = "//".concat(window.location.host, "/api/checkLogin?callback=") + encodeURIComponent(window.location.href);
                    console.log('handleUnauthorized strt. STANDARD ==>', redirectUrl);
                    window.location.href = redirectUrl;
                }, 2000);
            }
            else {
                if (window.location.host.indexOf('bfc.') !== -1) {
                    console.log('handleUnauthorized strt. bfc');
                    this.showError(message);
                    setTimeout(function () {
                        var redirectUrl = "//".concat(window.location.host, "/common-data/checkLogin?callback=") + encodeURIComponent(window.location.href);
                        console.log('handleUnauthorized strt. bfc ==>', redirectUrl);
                        window.location.href = redirectUrl;
                    }, 2000);
                }
                else {
                    var pos = url.indexOf('//');
                    pos = url.indexOf('/', pos + 2);
                    var baseUrl = url.substring(0, pos);
                    var pathAndQueryString = url.substring(pos);
                    var redirectUrl_1 = baseUrl + '/pages' + pathAndQueryString;
                    console.log('handleUnauthorized strt. default ==>', redirectUrl_1);
                    if (error.response.config.url.indexOf('/index/getPageHeader') !== -1) {
                        window.location.href = redirectUrl_1;
                    }
                    else {
                        this.showError(message);
                        setTimeout(function () {
                            window.location.href = redirectUrl_1;
                        }, 2000);
                    }
                }
            }
        };
        ServiceStatus.prototype.showLoading = function (request) {
            if (!request.hideLoading) {
                if (this.loadingRequests === 0) {
                    this.loading = this.openLoading(request);
                }
            }
            this.loadingRequests++;
        };
        ServiceStatus.prototype.hideLoading = function () {
            if (this.loadingRequests > 0) {
                this.loadingRequests--;
            }
            if (this.loadingRequests === 0) {
                this.closeLoading(this.loading);
            }
        };
        ServiceStatus.prototype.blurActiveElement = function () {
            var ele = document.activeElement;
            if (ele && ele.blur) {
                ele.blur();
            }
        };
        ServiceStatus.prototype.characterReplacer = function (config) {
            var nbsp = ' ';
            var space = ' ';
            var params = config.params;
            if (params) {
                Object.getOwnPropertyNames(params).forEach(function (key) {
                    if (params[key] && typeof params[key] === 'string' && params[key].indexOf(nbsp) !== -1) {
                        params[key] = params[key].replaceAll(nbsp, space);
                    }
                });
            }
            var data = config.data;
            if (data) {
                var json = JSON.stringify(data);
                if (json.indexOf(nbsp) !== -1) {
                    config.data = JSON.parse(json.replaceAll(nbsp, space));
                }
            }
        };
        ServiceStatus.prototype.addLanguage = function (config) {
            if (this.configData && this.configData.hideHeaderLanguageFlag) {
                return;
            }
            if (config) {
                var language = 'zh-CN';
                switch (this.i18n.locale) {
                    case 'en':
                        language = 'en-US';
                        break;
                }
                if (config && config.headers) {
                    config.headers.CurrentLanguage = language;
                }
            }
        };
        ServiceStatus.prototype.addScene = function (config) {
            if (config) {
                if (this.configData && this.configData.sceneData) {
                    if (config && config.headers) {
                        for (var key in this.configData.sceneData) {
                            if (this.configData.sceneData[key]) {
                                config.headers[key] = this.configData.sceneData[key];
                            }
                        }
                    }
                }
            }
        };
        ServiceStatus.prototype.isOnlyWarning = function (details) {
            if (details === void 0) { details = []; }
            if (!details || !details.length) {
                return false;
            }
            var result = true;
            for (var i in details) {
                if (details[i]) {
                    var item = details[i];
                    if (item.type !== '1') {
                        result = false;
                        break;
                    }
                }
            }
            return result;
        };
        ServiceStatus.prototype.openLoading = function (request) {
            BootstrapBus_1.busEvent.$emit(BootstrapBus_1.EventBusEnum.APPS_OPEN_LOADING, request);
        };
        ServiceStatus.prototype.closeLoading = function (loading) {
            BootstrapBus_1.busEvent.$emit(BootstrapBus_1.EventBusEnum.APPS_CLOSE_LOADING, loading);
        };
        ServiceStatus.prototype.showError = function (message) {
            BootstrapBus_1.busEvent.$emit(BootstrapBus_1.EventBusEnum.APPS_SHOW_ERROR, message);
        };
        ServiceStatus.prototype.showForbidden = function (message) {
            BootstrapBus_1.busEvent.$emit(BootstrapBus_1.EventBusEnum.APPS_FORBIDDEN_CHANGE, message);
        };
        ServiceStatus.prototype.showForbiddenDetail = function (messageData) {
            BootstrapBus_1.busEvent.$emit(BootstrapBus_1.EventBusEnum.APPS_FORBIDDEN_CHANGE_DETAIL, messageData);
        };
        ServiceStatus.prototype.showErrorWithDetail = function (message, details) {
            BootstrapBus_1.busEvent.$emit(BootstrapBus_1.EventBusEnum.APPS_SHOW_ERROR_DETAIL, { message: message, details: details });
        };
        return ServiceStatus;
    }());
    exports.ServiceStatus = ServiceStatus;
});
//# sourceMappingURL=ServiceStatus.js.map